import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { CalendarListEntry } from '../../interfaces/calendar';

import { MatSidenav } from '@angular/material/sidenav';

@Component({
  selector: 'mcrit-gestio-calendar-metadata',
  templateUrl: 'calendar-metadata.component.html',
  styleUrls: ['calendar-metadata.component.css']
})
export class CalendarMetadataComponent implements OnInit {
  @Input('calendarData') calendarData: CalendarListEntry;
  @Output('change') change = new EventEmitter();

  public subscriptions: {
    dashboard: boolean;
    'eventCreation': boolean;
    'eventChange': boolean;
    'eventCancellation': boolean;
    'eventResponse': boolean;
    'agenda': boolean;
  } = {
    dashboard: false,
    'eventCreation': false,
    'eventChange': false,
    'eventCancellation': false,
    'eventResponse': false,
    'agenda': false
  };


  public localizeACL(acl: string): string {
    let localized;
    switch (acl) {
      case 'freeBusyReader':
        localized = 'Només ocupat';
        break;
      case 'reader':
        localized = 'Només lectura';
        break;
      case 'writer':
        localized = 'Lectura i edició';
        break;
      case 'owner':
        localized = 'Propietari';
        break;
      default:
        localized = acl;
    }
    return localized;
  }

  public updateSubscription(subscriptionType, $event) {
    this.change.emit({
      id: this.calendarData.id,
      type: 'subscription',
      channel: subscriptionType,
      status: $event
    });
  }

  constructor() { }

  ngOnInit() {
    this.subscriptions.dashboard = this.calendarData.selected;
    if (this.calendarData.notificationSettings && this.calendarData.notificationSettings.notifications) {
      this.calendarData.notificationSettings.notifications.forEach(notification => {
        this.subscriptions[notification.type] = true;
      });
    }

  }

}
